import { useEffect, useMemo, useRef, useState } from 'react';

export function useStabilizedBlob(blob?: Blob) {
  const [digest, setDigest] = useState<string | undefined>(undefined);
  const isCancelled = useRef(false);

  useEffect(() => {
    isCancelled.current = false;

    const decode = async () => {
      if (!blob) return;

      const content = await blob.arrayBuffer();

      const hashBuffer = await crypto.subtle.digest('SHA-256', content);
      const digest = Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join();

      if (!isCancelled.current) {
        setDigest(digest);
      }
    };

    decode();

    return () => {
      isCancelled.current = true;
    };
  }, [blob]);

  const stabilized = useMemo(() => {
    return blob;
    // XXX: Dirty hack to prevent flickering due to re-renders of the document blob
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [digest]);

  return { blob: stabilized, key: digest };
}
